<template>
  <div>
    <QuestionnairModal
      ref="questionnairModal"
      :modalName="'questionnairModal'"
      :showPracticeView="showPracticeView"
      :showTestView="showTestView"
    />
    <div v-if="toShowTestView">
      <TestView
        :showQuestionnaireModal="showQuestionnaireModal"
        :showPracticeView="showPracticeView"
      />
    </div>
    <div v-if="toShowPracticeView">
      <PracticeView :showTestView="showTestView" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QuestionnairModal from '../../components/Vocabulary/PracticeView/QuestionnaireModal.vue'
import TestView from '../../components/Vocabulary/PracticeView/TestView.vue'
import PracticeView from '../../components/Vocabulary/PracticeView/PracticeView.vue'
import { MODES } from '../../components/Vocabulary/vocabularyMode'

export default {
  name: 'VocabularyPracticePage',
  components: {
    QuestionnairModal,
    TestView,
    PracticeView
  },
  data () {
    return {
      toShowTestView: true,
      toShowPracticeView: false,
      wordList: [],
      selectedWords: []
    }
  },
  mounted () {
    // if (
    //   this.mode === null ||
    //   (MODES.NOTEXAM.includes(this.mode) && (this.initSeq === null || this.maxSeqOfGlossary === null)) ||
    //   (MODES.EXAM.includes(this.mode) && (!this.testWordList || this.testWordList.length === 0)) ||
    //   (MODES.FORCEREVIEW === this.mode && !this.isUpgraded && (!this.selectedInitSeq || !this.selectedBlockSize)) ||
    //   (MODES.FORCEREVIEW === this.mode && this.isUpgraded && (!this.upgradedUserForceReviewWordList || this.upgradedUserForceReviewWordList.length === 0))
    // )
    if (
      this.mode === null ||
      (MODES.NOTEXAM.includes(this.mode) && (this.initSeq === null || this.maxSeqOfGlossary === null)) ||
      (MODES.EXAM.includes(this.mode) && (!this.testWordList || this.testWordList.length === 0)) ||
      (MODES.FORCEREVIEW === this.mode && (!this.upgradedUserForceReviewWordList || this.upgradedUserForceReviewWordList.length === 0))
    ) {
      this.$router.replace('/vocabulary')
      return
    }

    if (MODES.NOTEXAM.includes(this.mode) || MODES.FORCEREVIEW === this.mode) {
      this.showQuestionnaireModal()
    } else if (MODES.EXAM.includes(this.mode)) {
      this.showTestView()
    }
  },
  beforeRouteLeave (to, from, next) {
    const answer = this.leave
      ? true
      : window.confirm(this.$t('Common.alertLeavingPage'))
    if (answer) {
      next()
    } else {

    }
  },
  computed: {
    ...mapState({
      isUpgraded: (state) => state.vocabularyPractice.isUpgraded,
      mode: (state) => state.vocabularyPractice.mode,
      initSeq: (state) => state.glossary.initSeq,
      maxSeqOfGlossary: (state) => state.glossary.maxSeqOfGlossary,
      leave: (state) => state.vocabularyPractice.leave,
      testWordList: (state) => state.vocabularyPractice.testWordList,
      selectedInitSeq: state => state.vocabularyPractice.selectedInitSeq,
      selectedBlockSize: state => state.vocabularyPractice.selectedBlockSize,
      upgradedUserForceReviewWordList: state => state.glossary.upgradedUserForceReviewWordList
    })
  },
  methods: {
    showQuestionnaireModal () {
      this.$store.commit('vocabularyPractice/resetAll')
      this.toShowTestView = true
      this.$refs.questionnairModal.showModal()
    },
    showPracticeView () {
      this.toShowTestView = false
      this.toShowPracticeView = true
      this.$store.commit('vocabularyPractice/setToStartTest', false)
      this.$store.commit('vocabularyPractice/setToStartPractice', true)
      this.$store.commit('vocabularyPractice/setNextCurrentWord')
    },
    showTestView () {
      this.toShowPracticeView = false
      this.toShowTestView = true
      this.$store.commit('vocabularyPractice/setToStartPractice', false)
      this.$store.commit('vocabularyPractice/setToStartTest', true)
    }
  }
}
</script>
